import React from "react";
import "./Downhome.css";
const Downhome = () => {
  return (
    <section className="experience">
      <div className="apple">My Experience</div>
      <div className="icc">
        <ul className="lo1">
          <li>Website Developer</li>
          <li>Software Developer</li>
          <li>Digital Marketing</li>
          <li>Backend Developer</li>
        </ul>
      </div>
    </section>
  );
};

export default Downhome;
